import styled from 'styled-components';

export const Content = styled.div`
  padding: 0px;
  box-sizing: border-box;
  position: relative;
  min-height: 400px;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    height: auto;
  }
`;
export const Buttons = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 10px;
  left: 0;
  text-align: center;
  right: 0;
`;
export const Button = styled.button`
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-weight: 600;
  color: #e6eaec;
  border-radius: 10px;
  padding: 0 15px;
  border: 1px solid #3d4952;
  cursor: pointer;
  background: #1a2429;
  margin: 0;
  position: relative;
  transition: border-color 0.15s ease-in, color 0.15s ease-in, background 0.15s ease-in;
  &:hover {
    background: #232e35;
    border-color: #47b972;
    color: #5cc98a;
  }
`;
